"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Text = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lib_1 = require("../../lib");
const Text = ({ children, className, weight = 'default', size = '0_875', color = 's100', align }) => {
    return ((0, jsx_runtime_1.jsx)("div", Object.assign({ className: (0, lib_1.classnames)((0, lib_1.use)(className, className), (0, lib_1.use)(color, `type--${color}`), (0, lib_1.use)(align, `type--${align}`), (0, lib_1.use)(size, `type--${size}`), (0, lib_1.use)(weight, `type--${weight}`)) }, { children: children }), void 0));
};
exports.Text = Text;
//# sourceMappingURL=Text.js.map